<script>
import Vue from "vue";

const scrollDirective = {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        el.removeEventListener('scroll', f)
      }
    }
    el.addEventListener('scroll', f)
  }
}

export default scrollDirective
Vue.directive('scroll', scrollDirective)
</script>


// WEBPACK FOOTER //
// src/components/directives/Scroll.vue